import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GenericAddressCardStackContentViewModel } from './generic-address-card-stack-content-view-model';

@Component({
  selector: 'app-generic-address-card-stack-content',
  templateUrl: './generic-address-card-stack-content.component.html',
  styleUrls: ['./generic-address-card-stack-content.component.scss'],
  providers: [GenericAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GenericAddressCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
